import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import newsapp from "../assets/svg/projects/newsapp.jpg";
import todo from "../assets/svg/projects/todo.png";
import weather from "../assets/svg/projects/weather.jfif";
import chat from "../assets/svg/projects/chat.jfif";
import cam from "../assets/svg/projects/cam.jfif";
import ecom from "../assets/svg/projects/ecom.jfif";


export const projectsData = [
  {
    id: 1,
    projectName: "News Application",
    projectDesc:
      "This app shows news on the basis of different categories with sources and webpage available",
    tags: ["Flutter", "Dart", "API"],
    code: "https://github.com/rafay51698/News-App-Flutter",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: newsapp,
  },
  {
    id: 2,
    projectName: "Todo App",
    projectDesc: "This app shows tasks of users using cloud firestore",
    tags: ["Flutter", "Firebase", "GetX"],
    code: "https://github.com/rafay51698/Todo-App-Flutter-Fire",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: todo,
  },
  {
    id: 3,
    projectName: "Weather App",
    projectDesc:
      "Weather forecast systems and applications predict weather conditions based on multiple parameters.",
    tags: ["Flutter", "Dart", "API"],
    code: "https://github.com/rafay51698/Flutter-Weather-App",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: weather,
  },
  {
    id: 4,
    projectName: "E-Commerce App",
    projectDesc: "A Simple E-commerce application",
    tags: ["Flutter", "Dart"],
    code: "https://github.com/rafay51698/Hackathon-Application",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: ecom,
  },
  {
    id: 5,
    projectName: "Chat App",
    projectDesc: "A Simple and user-friendly chat application",
    tags: ["Flutter", "Firebase"],
    code: "https://github.com/rafay51698/Chat-App-Flutter-",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: chat,
  },
  {
    id: 6,
    projectName: "Camscanner App",
    projectDesc: "An app where you can scan sny document.",
    tags: ["Flutter", "OpenCv", "Document Scanner"],
    code: "https://github.com/rafay51698/Cam-Scanner-Flutter",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: cam,
  },
  //   {
  //     id: 7,
  //     projectName: "E-Commerce App",
  //     projectDesc: "A Simple E-commerce application",
  //     tags: ["React Native", "Firebase"],
  //     code: "https://github.com/hhhrrrttt222111/developer-portfolio",
  //     demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
  //     image: five,
  //   },
];


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/